import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export type BadgeType = 'not-started' | 'in-progress' | 'completed' | 'blue' | 'gray' | 'danger';

/** Status pill (design: radius 999, 12px/500, tinted background). */
@Component({
  selector: 'mbm-badge',
  imports: [TranslateModule],
  templateUrl: './mbm-badge.component.html',
  styleUrl: './mbm-badge.component.scss',
})
export class MbmBadgeComponent {
  readonly labelKey = input<string>();
  readonly label = input<string>();
  readonly variant = input.required<BadgeType>();
}
